import * as THREE from 'three';
import {MINERAL_DEFS,WORLD,type ChipId,type MineralKind} from './config';
import {spawnMineral,spawnToolPickup,type Mineral} from './minerals';
import {stageForLevel} from './stages';
import type {SeededRandom} from '../utils/random';
import type {RefillMode} from './match';

export class Replenishment {
  private timer=0;
  private nextId=10000;
  private limit=0;
  spawned=0;
  pickups=0;
  message='';
  private messageTime=0;
  reset(initialCount:number):void {this.timer=0;this.nextId=10000;this.limit=initialCount;this.spawned=0;this.pickups=0;this.message='';this.messageTime=0;}
  update(dt:number,mode:RefillMode,level:number,rng:SeededRandom,minerals:Mineral[],scene:THREE.Scene):Mineral[] {
    this.messageTime=Math.max(0,this.messageTime-dt);if(!this.messageTime)this.message='';
    if(mode==='off')return [];
    this.timer+=dt;
    const active=minerals.filter(m=>m.active);
    const interval=mode==='lively'?6:10;
    if(this.timer<interval)return [];
    this.timer=0;
    const missing=this.limit-active.length;
    if(missing<=0)return [];
    const pool:MineralKind[]=[...stageForLevel(level).signature,'goldNugget','cyanCrystal','diamond'];
    const tools:ChipId[]=['rescueBell','mossShield','twinHook','starElixir'];
    const result:Mineral[]=[];
    const count=Math.min(missing,mode==='lively'?4:3);
    for(let n=0;n<count;n++){
      const pickup=n===0&&active.filter(m=>m.pickup).length+result.filter(m=>m.pickup).length<3&&rng()<.5;
      const kind:MineralKind=pickup?'starDust':rng()<.1?(rng()<.7?'rock':'dynamite'):pool[Math.floor(rng()*pool.length)];
      const radius=pickup ? .6 : MINERAL_DEFS[kind].radius;
      for(let attempt=0;attempt<240;attempt++){
        const x=-13+rng()*26,y=1-rng()*11.3;
        if(![-4.2,4.2].some(p=>Math.abs(Math.atan2(x-p,WORLD.pivotY-y))<.86&&Math.hypot(x-p,WORLD.pivotY-y)<22))continue;
        if([...active,...result].some(m=>Math.hypot(x-m.x,y-m.y)<radius+m.radius+.35))continue;
        const item=pickup?spawnToolPickup(this.nextId++,tools[Math.floor(rng()*tools.length)],x,y,scene):spawnMineral(this.nextId++,kind,x,y,scene);
        result.push(item);this.spawned++;if(pickup)this.pickups++;break;
      }
    }
    if(result.length){this.message=`新矿脉 +${result.length}${result.some(m=>m.pickup)?' · 魔法补给出现':''}`;this.messageTime=3;}
    return result;
  }
}
